import { usePostgresLayer } from "../../../hooks/layer/usePostgresLayer";

export const useRasterLayer = (layerName: string): boolean => {
  const { postgresLayer } = usePostgresLayer(layerName, { waitInput: true });

  return !!postgresLayer && !!postgresLayer.style && postgresLayer.style.hasRasters();
};
